import { PartialType, PickType } from '@nestjs/swagger';
import { ContractorUserCreatableInterface } from '../interfaces/contractor-user-creatable.interface';
import { ContractorUserDto } from './contractor-user.dto';

export class ContractorUserCreateDto
  extends PartialType(PickType(ContractorUserDto, ['userId', 'contractorId']))
  implements ContractorUserCreatableInterface {}
